import axios from 'axios';

const baseURL = process.env.NODE_ENV === 'production'
  ? '/public/backend/api/v1/'
  : 'http://localhost:8888/public/backend/api/v1/';

const options = {
  baseURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

const instance = axios.create(options);

export async function apiGet(url) {
  try {
    const response = await instance.get(url);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function apiPost(url, request) {
  try {
    const response = await instance.post(url, request);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function apiPut(url, request) {
  try {
    const response = await instance.put(url, request);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
